import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { loadingReducer } from "./reducer/loading";
import {
  accountTypeReducer,
  authReducer,
  newRegisterUserReducer,
  profileReducer,
} from "./reducer/auth";
import { createAuctionReducer, rescheduleAuctionReducer } from "./reducer/createAuction";
import {
  asideFilterAuctionReducer,
  eventAuctionReducer,
  filterAuctionReducer,
  readLiveOffersReducer,
  getAllLiveAuctionForSeller,
  getAllTodayUpComingAuctionData,
  sellerAllAuctionReducer,
} from "./reducer/auctionEvent";
import { helplineReducer } from "./reducer/helpline";
import { createOfferReducer } from "./reducer/createOffer";
import {
  getWalletReducer,
  recentTransactionReducer,
  withdrawalsReducer,
  refundsReducer,
  AddBankReducer,
  AddMoneyToWalletReducer,
  emdTranscationReducer,
} from "./reducer/wallet";
import {
  buyerPiadEmdReducer,
  buyerTodayReducer,
  buyerUpcomingReducer,
  getTodayOffersReducer,
  getAllInvitesReducer
} from "./reducer/buyer";
import { allDocumentsReducer } from "./reducer/document";
import { allSubscriptionReducer } from "./reducer/subscription";
import {
  catelogueReducers,
  getCatelogueViewPdfReducer,
} from "./reducer/catalogue";
import { singleUrlReducer } from "./reducer/singleFile";
import {
  inspectionForSellerReducer,
  inspectionRequestReducer,
  inspectionResponseReducer,
} from "./reducer/inspectionRequest";
import { pcbOfferReducer } from "./reducer/pcbOffer";
import {
  PayDepositReducer,
  confirmLotsPaymentsReducer,
} from "./reducer/confirmLotspayment";

import { notificationReducer } from "./reducer/notification";
import {
  analysticsValueReducer,
  createAuctionAnalysticsReducer,
  transcationAnalysticsReducer,
} from "./reducer/analystics";
import { singleBrandReducer } from "./reducer/singleBrand";
import { organizationAuctionReducer } from "./reducer/organization";
import { publicTableReducer } from "./reducer/landing";
import { singleAuctionReducer } from "./reducer/singleAuction";
import {
  allPickupDetailsReducer,
  bidsReducer,
  cancelPickupReducer,
  raisePickupReducer,
} from "./reducer/bid";
import { allLiveAuctionListReducer, allSellerLiveAuctionReducer, singleAuctionIndustryReducer } from "./reducer/liveRoom";
import { gstVerificationReducer } from "./reducer/gtsVerification";
import { materialClassificationsReducer } from "./reducer/classificationScrap";
import { startingPriceApprovalReducer } from "./reducer/price";
import { auctionReportReducer, getAuctionReportViewPdfReducer } from "./reducer/auctionReport";

const reducer = combineReducers({
  account: authReducer,
  newRegisterUser: newRegisterUserReducer,
  accountTypes: accountTypeReducer,
  loading: loadingReducer,
  createAuction: createAuctionReducer,
  eventAuction: eventAuctionReducer,
  singleAuction: singleAuctionReducer,
  sellerAllAuction: sellerAllAuctionReducer,
  filterAuction: filterAuctionReducer,
  asideFilterAuction: asideFilterAuctionReducer,
  helpline: helplineReducer,
  createOffer: createOfferReducer,
  organizationDetails: organizationAuctionReducer,
  wallet: getWalletReducer,
  addMoneyToWallet: AddMoneyToWalletReducer,
  recentTransaction: recentTransactionReducer,
  withdrawals: withdrawalsReducer,
  emdTranscation:emdTranscationReducer,
  refundsStore: refundsReducer,
  addBank: AddBankReducer,
  buyerToday: buyerTodayReducer,
  buyerUpcoming: buyerUpcomingReducer,
  buyerPiadEmd: buyerPiadEmdReducer,
  allInvites: getAllInvitesReducer,

  allDocuments: allDocumentsReducer,
  allSubscriptionData: allSubscriptionReducer,
  catelogueData: catelogueReducers,
  catelogueViewPdf: getCatelogueViewPdfReducer,
  singleFile: singleUrlReducer,
  inspectionrequestion: inspectionRequestReducer,
  pcbOffers: pcbOfferReducer,
  inspectionResponse: inspectionResponseReducer,
  confirmPaymentsLots: confirmLotsPaymentsReducer,
  PayDeposits: PayDepositReducer,
  profileStore: profileReducer,
  notifications: notificationReducer,
  analysticsData: analysticsValueReducer,
  transcationAnalystics: transcationAnalysticsReducer,
  createAuctionAnalystics: createAuctionAnalysticsReducer,
  inspectionForSeller: inspectionForSellerReducer,
  singleBrand: singleBrandReducer,
  liveOffersStore: readLiveOffersReducer,
  todayOffersStore: getTodayOffersReducer,
  publicTable: publicTableReducer,
  sellerLiveAuction: getAllLiveAuctionForSeller,
  sellerTodayUpcoming: getAllTodayUpComingAuctionData,
  bids: bidsReducer,
  raisePickup: raisePickupReducer,
  allPickup: allPickupDetailsReducer,
  cancelPickup: cancelPickupReducer,
  liveAuctionList: allLiveAuctionListReducer,
  gstVerification: gstVerificationReducer,
  materialClassifications: materialClassificationsReducer,
  sellerLiveAuctionList: allSellerLiveAuctionReducer,
  startingPriceApproval: startingPriceApprovalReducer,
  auctionReport: auctionReportReducer,
  rescheduleAuction: rescheduleAuctionReducer,
  getAuctionReportViewPdf: getAuctionReportViewPdfReducer,
  singleAuctionIndustry: singleAuctionIndustryReducer
});

const initialstate = {};
const middleware = [thunk];
const store = createStore(
  reducer,
  initialstate,
  applyMiddleware(...middleware)
);

export default store;
